export default __webpack_public_path__ + "static/media/pin.0b3d60a0.png";